import {ChangeDetectorRef, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CurrencyPipe} from '@angular/common';
import {InsurancePaymentOverpayListModel} from '../../models/insurance-payment-overpay-list.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { UiService } from 'src/app/services/ui.service';

@Component({
  standalone: false,
  selector: 'app-ar-insurance-payment-overpay-confirm',
  templateUrl: './ar-insurance-payment-overpay-confirm.component.html',
  styleUrls: ['./ar-insurance-payment-overpay-confirm.component.scss']
})
export class ArInsurancePaymentOverpayConfirmComponent implements OnInit {
  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;

  overPayOriginal: number = 0;
  overPayAmount: number = 0;
  overPayAmountRemaining: number = 0;
  overPayAmountList: InsurancePaymentOverpayListModel[] = [];
  isSinglePatient: boolean = true;
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<ArInsurancePaymentOverpayConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private currencyPipe: CurrencyPipe,
              private dialog: MatDialog,
              private changeDetectorRef: ChangeDetectorRef,
              private readonly uiService: UiService) { }

  ngOnInit(): void {
    if (this.data.overPayAmount) {
      this.overPayOriginal = this.data.overPayAmount.toFixed(2);
      this.overPayAmount = this.data.overPayAmount.toFixed(2);
      this.overPayAmountRemaining = this.data.overPayAmount.toFixed(2);
    }

    if (this.data.overPayAmountList) {
      this.overPayAmountList = this.data.overPayAmountList;
    }
    this.changeDetectorRef.detectChanges();
  }

  cancelClick() {
    this.overPayAmountList = [];
    this.dialogRef.close(this.overPayAmountList);
  }

  createCreditClick() {
    // this.dialogRef.close(true);
    this.dialogRef.close(this.overPayAmountList);
  }

  saveAmountEntered(event, claim: InsurancePaymentOverpayListModel) {
    const amountEntered: number = Number(event.value.replace(/[^0-9.-]+/g,''));

    // maybe
    // given change, get new amount not/distributed
    let amountDistributed = 0;
    let amountNotDistributed = 0;
    this.overPayAmountList.forEach(li => {
      if (li.ClaimNumber !== claim.ClaimNumber) {
        amountDistributed += ConversionUtilities.roundDecimal(li.Amount);
      }
    });
    amountNotDistributed = ConversionUtilities.roundDecimal(this.overPayOriginal - amountDistributed);


    if (amountEntered > amountNotDistributed) {
      // amount too high
      this.overPayAmountList.forEach(a => {
        if (a.PatientID === claim.PatientID && a.ClaimNumber === claim.ClaimNumber) {
          a.Amount = 0;
        }
      });
      this.createMessage('Amount entered is more than amount remaining.', 'Error');
    }
    else {
      // set amount
      this.overPayAmountList.forEach(a => {
        if (a.PatientID === claim.PatientID && a.ClaimNumber === claim.ClaimNumber) {
          a.Amount = amountEntered;
        }
        amountDistributed += a.Amount;
      });
    }

    // set remaining amount
    this.overPayAmountRemaining = this.overPayOriginal - amountDistributed;

    this.tdoTable.updateData(this.overPayAmountList);
    this.changeDetectorRef.detectChanges();
  }

  createMessage(message, type) {
    this.uiService.displayMessage(type, message);
  }
}
